// Update List of Roles Manually

const roleTypes = {
  BookATrip: "Book A Trip",
  MemberSearch: "Member Search",
  Reports: "Reports",
  NetNotes: "NetNotes",
  Admin: "Admin",
  CompanyAdmin: "Company Admin",
  Demo: "Demo",
  StandingOrder: "Standing Order",
};

export default roleTypes;
